import Vue from 'vue'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import { createPinia, PiniaVuePlugin } from "pinia";
window.Vue = Vue;

import { BootstrapVue } from "bootstrap-vue";
import vClickOutside from "v-click-outside";
import VueMask from "v-mask";
import Vuelidate from "vuelidate";
import VueApexCharts from "vue-apexcharts";
import * as VueGoogleMaps from "vue2-google-maps";
import VueSweetalert2 from "vue-sweetalert2";
import VueRouter from 'vue-router';
import VueMoment from 'vue-moment';
import VueToastr from "vue-toastr";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";
//Import Vue Filter
require('./Pages/assets/filter');
//Import Sweetalert2
import Swal from 'sweetalert2';
//Import progressbar
require('./Pages/assets/cutomProgressbar');
import vueTopprogress from 'vue-top-progress'

import $ from 'jquery'; 
window.$ = $;
//Bootstrap and jQuery libraries
import 'jquery/dist/jquery.min.js';
//Datatable Modules
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import "datatables.net-buttons/js/dataTables.buttons.js"
import "datatables.net-buttons/js/buttons.colVis.js"
import "datatables.net-buttons/js/buttons.flash.js"
import "datatables.net-buttons/js/buttons.html5.js"
import "datatables.net-buttons/js/buttons.print.js"
import "bootstrap-vue/dist/bootstrap-vue.css";

window.Swal = Swal
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  onOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
window.Toast = Toast

Vue.prototype.$isDev = process.env.MIX_APP_ENV !== "production";
Vue.config.devtools = Vue.prototype.$isDev;
Vue.config.debug = Vue.prototype.$isDev;
Vue.config.silent = !Vue.prototype.$isDev;
import tinymce from "vue-tinymce-editor";


Vue.use(VueRouter)
Vue.use(BootstrapVue);
Vue.use(PiniaVuePlugin);
Vue.use(vClickOutside);
Vue.use(VueMask);
Vue.use(Vuelidate);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.use(VueCroppie);
Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE",
        libraries: "places"
    },
    installComponents: true
});
Vue.component("apexchart", VueApexCharts);
Vue.component("tinymce", tinymce);
Vue.component(
  "dynamic-component",
  require("../js/Pages/components/dynamic-component").default
);
Vue.use(vueTopprogress)

import { Link } from '@inertiajs/inertia-vue'
import { Head } from '@inertiajs/inertia-vue'
import JsonExcel from "vue-json-excel";
/**
* The following block of code may be used to automatically register your
* Vue components. It will recursively scan this directory for the Vue
* components and automatically register them with their "basename".
*
* Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
*/
/**
* Next, we will create a fresh Vue application instance and attach it to
* the page. Then, you may begin adding components to this application
* or customize the JavaScript scaffolding to fit your unique needs.
*/

// import "../js/Pages/views";
// import Layouts from "../js/Pages/mixins/layouts.mixin";

// const app = new Vue({
//   el: "#app",
//   mixins: [Layouts]
// });
Vue.use(VueMoment);
Vue.use(VueToastr);
Vue.moment();
createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => `${title} | SeQwens`,
  setup({ el, App, props, plugin }) {
    Vue.use(createPinia());
    Vue.use(plugin)
    Vue.component('Link', Link)
    Vue.component('Head', Head)
    Vue.component("downloadExcel", JsonExcel);
    Vue.mixin({ methods: {route} })
    new Vue({
      render: h => h(App, props),
    }).$mount(el)
  },
});


InertiaProgress.init({
  showSpinner: true
});